import { Grommet } from 'grommet'
import { ModalProvider as NZKModalProvider } from 'nzk-react-components'
import React, { useEffect, useState } from 'react'
import { StripeProvider } from 'react-stripe-elements'
import { ToastContainer } from 'react-toastify'
import ErrorBoundary from './ErrorBoundary'
import Theme from './Theme'
import config from '../config'
import { ApolloProvider } from '../lib/apollo'
import { AppState } from '../state/AppState'
import { CurrentUserStateProvider } from '../state/CurrentUserState'
import { ModalProvider } from '../state/ModalState'
import { ThemeState } from '../state/ThemeState'
import theme from '../theme'

type Props = {
  children: React.ReactNode
}

const getStripe = () => {
  if (typeof window === 'undefined') return null
  // @ts-ignore
  if (!window.Stripe) return null
  // @ts-ignore
  return window.Stripe(config.stripeKey)
}

const StripeRootProvider = ({ children }: Props) => {
  const [stripe, setStripe] = useState(getStripe)

  useEffect(() => {
    if (stripe) return undefined
    const interval = window.setInterval(() => {
      const loadedStripe = getStripe()
      if (loadedStripe) setStripe(loadedStripe)
    }, 100)
    return () => window.clearInterval(interval)
  }, [stripe])

  return <StripeProvider stripe={stripe}>{children}</StripeProvider>
}

const RootElement = ({ children }: Props) => (
  <ErrorBoundary>
    <ApolloProvider>
      <AppState.Provider>
        <CurrentUserStateProvider>
          <ThemeState.Provider>
            <StripeRootProvider>
              <Grommet theme={theme}>
                <Theme>
                  <NZKModalProvider>
                    <ModalProvider>
                      {children}
                      <ToastContainer position='bottom-right' autoClose={3000} />
                    </ModalProvider>
                  </NZKModalProvider>
                </Theme>
              </Grommet>
            </StripeRootProvider>
          </ThemeState.Provider>
        </CurrentUserStateProvider>
      </AppState.Provider>
    </ApolloProvider>
  </ErrorBoundary>
)

export const wrapRootElement = ({ element }) => (
  <RootElement>{element}</RootElement>
)

export default RootElement
